import { CustomTooltip } from "../CustomTooltip/CustomTooltip";
import { useTranslation } from "react-i18next";
import { useAppSelector, useIsLoggedSelector } from "../../../services/hooks.service";
import { OrderSide } from "../../../_utils/types";
import { MainCard } from "../MainCard/MainCard";
import "./TotalBalance.scss";
import { amountValueFormate, formatNumber } from "../../../_utils";
import { initialDepositBalanceState, useGetBalancesQuery } from "@ultrade/react-sdk";

export const TotalBalance = () => {
  const { t } = useTranslation();
  const side = useAppSelector((state) => state.exchange.buySellTab);
  // const depositBalance = useAppSelector((state) => state.exchange.depositBalance);
  const selectedPair = useAppSelector((state) => state.user.selectedPair);
  const isLogged = useIsLoggedSelector();

  const { data: depositBalance = initialDepositBalanceState } = useGetBalancesQuery(selectedPair.pair_key, {
    skip: !isLogged,
    refetchOnMountOrArgChange: true,
  });

  const renderAvailableBalance = () => {
    let available = "0";
    if (side === OrderSide.Buy) {
      available = depositBalance?.price_available_balance 
        ? amountValueFormate(depositBalance?.price_available_balance,selectedPair?.price_decimal)
        : "0";
    }
    else {
      available = depositBalance?.base_available_balance 
        ? amountValueFormate(depositBalance?.base_available_balance,selectedPair?.base_decimal)
        : "0";
    }
    return available;
  }

  return (
    <MainCard className="total-balance-card">
      <div className="total-balance-container">
        <div className="label">{t("obd_tooltips.total_available_short")}:</div>
        <div className="balance">{formatNumber(renderAvailableBalance())}</div>
        <div className="currency">{side === OrderSide.Buy ? selectedPair?.price_currency?.toUpperCase() : selectedPair?.base_currency?.toUpperCase()}</div>
        <CustomTooltip text={t("obd_tooltips.total_available_balance_description")}>
          <i className="far exclamation-icon fa-exclamation-circle"></i>
        </CustomTooltip>
      </div>
    </MainCard>
  )
};
